// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__bC9vi","margin":"style_margin__EpDla"};